
<div>
  <div class="d-flex justify-content-between mb-3">
    <div class="title">Material Request</div>
  </div>
  <div v-if="!occurrence.materialRequestGuid">
    <div class="alert alert-info">
      <p>This technical occurrence is not linked to a material request.</p>
    </div>

    <p class="mt-3">
      <button class="badgebutton active" @click="createMaterialRequest">
        <i class="far fa-plus"></i>
        Create Material Request
      </button>
    </p>
  </div>
  <div v-else>
    <div class="alert alert-success">
      <p>This technical occurrence is linked to Material Request: {{ materialRequest.name }}</p>
    </div>

    <p class="mt-3">
      <button class="badgebutton active" @click="navigateMaterialRequest">
        <i class="far fa-link"></i>
        Go to Material Request
      </button>
    </p>
  </div>
</div>
